export const SettledStatuses = Object.freeze({
  FULFILLED: "fulfilled",
  REJECTED: "rejected",
});

/**
 * Sorts out failed requests from successful ones.
 * @param results return value of Promise.allSettled
 */
export const augmentSettledPromiseResults = (results) => {
  const responses = results
    .filter((result) => result.status === SettledStatuses.FULFILLED)
    .map((result) => result.value);
  const failedRequests = results.filter(
    (result) => result.status === SettledStatuses.REJECTED
  );

  return {
    responses,
    failedRequests,
    all: results,
  };
};
